import { ReactElement } from 'react';
import styled from 'styled-components';

type IndeterminateCheckBoxProps = {
  checked: boolean;
  indeterminate?: boolean;
  cssClass?: string;
  stopPropagation?: boolean;
  extendTouchArea?: boolean;
};

export const IndeterminateCheckBox = ({
  checked,
  cssClass,
  extendTouchArea,
  indeterminate = false,
  stopPropagation = true,
  ...rest
}: IndeterminateCheckBoxProps): ReactElement => {
  return (
    <Checkbox
      extendTouchArea={extendTouchArea}
      type='checkbox'
      ref={(input) => {
        if (input) {
          input.checked = checked;
          input.indeterminate = indeterminate as boolean;
        }
      }}
      onClick={(e) => stopPropagation && e.stopPropagation()}
      {...rest}
      className={`select-all ${cssClass}`}
    />
  );
};

type CheckboxProps = Pick<IndeterminateCheckBoxProps, 'extendTouchArea'>;

const Checkbox = styled.input<CheckboxProps>`
  ${(props) =>
    props.extendTouchArea &&
    `position: relative;
      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        }`}
`;
